import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { getWindow } from 'ssr-window';

@Directive({
  selector: '[appSneakPeak]'
})
export class SneakPeakDirective implements AfterViewInit, OnDestroy {

  @Input() appSneakPeak = '';
  @Input() sneakPeakHeight = 0;

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    this.animateOnScroll();
  }

  scrollUpTimer?: NodeJS.Timeout;
  scrollDownTimer?: NodeJS.Timeout;
  animateOnScroll = () => {
    this.scrollUpTimer = setTimeout(() => {
      const sneakElement = this.el.nativeElement.querySelector(this.appSneakPeak);

      if (sneakElement.getBoundingClientRect) {
        const { top, height } = sneakElement.getBoundingClientRect();

        this.el.nativeElement.style.setProperty('transition', 'transform 1s cubic-bezier(0.16, 1, 0.3, 1)');
        this.el.nativeElement.style.setProperty('transform', `translateY(-${top - getWindow().innerHeight + height + this.sneakPeakHeight}px)`);

        this.scrollDownTimer = setTimeout(() => {
          this.el.nativeElement.style.setProperty('transition', 'transform 1s cubic-bezier(0.7, 0, 0.84, 0)');
          this.el.nativeElement.style.setProperty('transform', `translateY(0px)`);
        }, 1000);
      }
    }, 2000);
  }

  @HostListener('window:scroll')
  onScroll() {
    if (this.scrollUpTimer) {
      clearTimeout(this.scrollUpTimer);
      delete this.scrollUpTimer;
    }
  }

  ngOnDestroy(): void {
    if (this.scrollUpTimer) {
      clearTimeout(this.scrollUpTimer);
    }
    if (this.scrollDownTimer) {
      clearTimeout(this.scrollDownTimer);
    }
  }
}
